import React from 'react';
import { bool } from 'prop-types';
import { useIntl } from '../../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import { Form, Button, FieldTextInput } from '../../../components';
import { composeValidators, emailFormatValid, required } from '../../../util/validators';

import css from './ContactForm.module.css';

const ContactFormComponent = props => {
  const intl = useIntl();

  return (
    <FinalForm
      {...props}
      render={fieldRenderProps => {
        const {
          rootClassName,
          className,
          handleSubmit,
          initialValues,
          inProgress,
          invalid,
          ready,
        } = fieldRenderProps;

        const hasUserEmail = !!initialValues.email;
        const submitDisabled = invalid || inProgress || ready;

        return (
          <Form
            className={classNames(rootClassName || css.root, className)}
            onSubmit={handleSubmit}
          >
            <FieldTextInput
              className={classNames(css.input, { [css.hidden]: hasUserEmail })}
              type="email"
              id="email"
              name="email"
              autoComplete="email"
              label={intl.formatMessage({ id: 'General.emailLabel' })}
              placeholder={intl.formatMessage({ id: 'General.emailPlaceholder' })}
              validate={composeValidators(
                required(intl.formatMessage({ id: 'General.emailRequired' })),
                emailFormatValid(intl.formatMessage({ id: 'General.emailInvalid' }))
              )}
            />
            <FieldTextInput
              className={css.input}
              type="textarea"
              id="message"
              name="message"
              maxLength={1600}
              label={intl.formatMessage({ id: 'ContactForm.messageLabel' })}
              placeholder={intl.formatMessage({ id: 'ContactForm.messagePlaceholder' })}
              validate={required(intl.formatMessage({ id: 'ContactForm.messageRequired' }))}
            />

            <Button
              className={css.button}
              type="submit"
              inProgress={inProgress}
              disabled={submitDisabled}
              ready={ready}
            >
              {intl.formatMessage({ id: 'General.send' })}
            </Button>
          </Form>
        );
      }}
    />
  );
};

ContactFormComponent.defaultProps = { inProgress: false, ready: false };

ContactFormComponent.propTypes = {
  inProgress: bool,
  ready: bool,
};

const ContactForm = ContactFormComponent;

export default ContactForm;
